// https://firebase.google.com/docs/web/modular-upgrade
import { initializeApp, getApps } from "firebase/app"
import { getFunctions, connectFunctionsEmulator } from "firebase/functions"
import {
  // getFirestore,
  initializeFirestore,
  connectFirestoreEmulator,
} from "firebase/firestore"
import {
  getAuth,
  connectAuthEmulator,
  setPersistence,
  inMemoryPersistence,
} from "firebase/auth"
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check"

// config
const firebaseConfig = {
  apiKey: "AIzaSyCVgaDRuAGpLCVUddXfFEyHjmYWuXpjtqQ",
  authDomain: "asiarestos.firebaseapp.com",
  projectId: "asiarestos",
  storageBucket: "asiarestos.appspot.com",
  messagingSenderId: "745471326238",
  appId: "1:745471326238:web:d29d8d4dcfabc0f8f9560f",
}

let Firestore
let Functions
let Auth
let AppCheck

const validPaths = [
  "/",
  "/sys",
  "/terms",
  "/order",
  "/menu",
  "/admin",
  "/admin/settings",
  "/admin/settings/resto",
  "/admin/settings/notification",
  "/admin/settings/internal",
  "/admin/settings/resto",
  "/admin/settings/prices",
  "/admin/settings/menu",
  "/admin/settings/analytics",
  "/admin/settings/reviews",
]

if (typeof window !== "undefined") {
  if (validPaths.includes(window.location.pathname)) {
    console.log(`🔖 APP ENV = ${process.env.NEXT_PUBLIC__APP_ENV}`)
    console.log(`🔖 NODE ENV = ${process.env.NODE_ENV}`)

    if (!getApps().length) {
      console.log("✅ Create App")
      const app = initializeApp(firebaseConfig)

      if (process.env.NEXT_PUBLIC__APP_ENV !== "production") {
        if (!process.env.NEXT_PUBLIC__APP_TOKEN) {
          throw new Error(
            "NEXT_PUBLIC__APP_TOKEN is not defined. Please set it in your environment variables."
          )
        }
        console.log("⚠️ Add debug app check token")
        self.FIREBASE_APPCHECK_DEBUG_TOKEN = process.env.NEXT_PUBLIC__APP_TOKEN
      }

      console.log("✅ Initialize app verification")
      AppCheck = initializeAppCheck(app, {
        provider: new ReCaptchaEnterpriseProvider(
          "6LeseB8rAAAAAPvw6iX39EJT57HdYjUPJG7K6GZJ"
        ),
        isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
      })

      console.log("✅ Initialize database client")
      Firestore = initializeFirestore(app, {
        experimentalAutoDetectLongPolling:
          process.env.NEXT_PUBLIC__APP_ENV !== "production",
      })

      console.log("✅ Initialize backend client")
      Functions = getFunctions(app, "europe-west3")

      console.log("✅ Initialize authentication client")
      Auth = getAuth(app)

      // if (process.env.NEXT_PUBLIC__APP_ENV === "test") {
      //   console.log("⚠️ Set AUTH persistence = NONE")
      //   setPersistence(Auth, inMemoryPersistence)
      // }

      console.log("🍓 GCP Connection Initialized! (app)")

      // export const Storage = getStorage(app)

      // local emulator
      if (process.env.NEXT_PUBLIC__APP_ENV !== "production") {
        console.log("⚠️ Connect to emulator")
        // connectStorageEmulator(Storage, "localhost", 9199)
        connectFirestoreEmulator(Firestore, "localhost", 8080)
        connectFunctionsEmulator(Functions, "localhost", 5001)
        connectAuthEmulator(Auth, "http://localhost:9099")
      }
    } else {
      console.log("✅ App already initialized")
    }
  } else {
    console.log("⚠️ App not initialized!")
  }
}

export { Firestore, Auth, Functions, AppCheck }
